import gql from 'graphql-tag';

export default gql ` 
query listActivitiesForCurrentUser($actDate: String, $nextToken:String, $limit:Int){
  listActivitiesForCurrentUser(actDate: $actDate, nextToken:$nextToken, limit:$limit){
        items {
        id
        actDate
        username
        activityType
        value
        intensity
        notes
        timestamp
        }
        nextToken
    }
}`;


// WEBPACK FOOTER //
// ./src/components/queries/ListActivitiesForCurrentUser.js